module.exports = __webpack_public_path__ + "img/img_realtime_hover.718b5a21.svg";